import { render } from "./PartnerInternalMemo.vue?vue&type=template&id=6ad6979e&scoped=true&ts=true"
import script from "./PartnerInternalMemo.vue?vue&type=script&lang=ts"
export * from "./PartnerInternalMemo.vue?vue&type=script&lang=ts"

import "./PartnerInternalMemo.vue?vue&type=style&index=0&id=6ad6979e&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad6979e"]])

export default __exports__